import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { api } from '../api/client';
import { disconnectSocket } from '../api/socket';
import { PRODUCT_NAME, STANDALONE } from '../platform';
import { useAuth } from '../store/auth';

/** Barra do sistema fora da partida (lobby, simulador, conta, admin). */
export function TopBar() {
  const { t } = useTranslation();
  const user = useAuth((s) => s.user);
  const clear = useAuth((s) => s.clear);
  const qc = useQueryClient();
  const navigate = useNavigate();
  const logout = async () => {
    await api.call('logout').catch(() => undefined);
    disconnectSocket();
    clear();
    qc.clear();
    navigate('/entrar');
  };
  return (
    <>
      <div className="bg-secret py-0.5 text-center font-mono text-[10px] font-bold tracking-[0.18em] text-white">
        OSTENSIVO // SISTEMA C2 · {STANDALONE ? 'OFFLINE' : user?.username.toUpperCase()}
      </div>
      <header className="flex h-11 items-center gap-4 overflow-x-auto border-b border-line bg-panel px-4 font-mono text-[12px] tracking-[0.1em]">
        <Link to="/" className="font-bold text-amber">
          {(STANDALONE ? PRODUCT_NAME : t('app.name')).toUpperCase()}
        </Link>
        <nav className="flex flex-1 gap-4 text-muted" data-tour="topbar-nav">
          <Link to="/" className="text-muted hover:text-amber">
            {STANDALONE ? 'CAMPANHAS' : t('nav.lobby').toUpperCase()}
          </Link>
          <Link to="/simulador" className="text-muted hover:text-amber">
            {t('nav.simulator').toUpperCase()}
          </Link>
          {user?.role === 'admin' && (
            <Link to="/admin" className="text-muted hover:text-amber">
              {t('nav.admin').toUpperCase()}
            </Link>
          )}
          {!STANDALONE && (
            <Link to="/conta" className="text-muted hover:text-amber">
              {t('nav.account').toUpperCase()}
            </Link>
          )}
        </nav>
        {!STANDALONE && (
          <button type="button" onClick={() => void logout()} className="text-muted hover:text-amber">
            {t('nav.logout').toUpperCase()}
          </button>
        )}
      </header>
    </>
  );
}
